import { Fragment } from 'react';
import { rage } from '~/rage';
import { Layouts } from '~/shared';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { StyledBackground } from './Background.styled';

const Background = () => (
	<Fragment>
		{rage.config.isStub() && (
			<BgPlaceholder $type={PlaceholderType.CarMarket} />
		)}
		<StyledBackground className={`${Layouts.CarMarket}-background`} />
	</Fragment>
);

export { Background };
